import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Priority SetFilter] Action',
  ResetFilter: '[Priority ResetFilter] Action',
}

const initialPriorityState: IPriorityState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IPriorityState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Priority', whitelist: ['filter']},
  (state: IPriorityState = initialPriorityState, action: ActionWithPayload<IPriorityState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialPriorityState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
